import HttpClienteToken from '../../services/HttpClientToken';

import { TipoPromocionProps } from '../../interfaces/catalogos/TipoPromocionInterface';

export const TiposPromocion = () => {

    return new Promise<TipoPromocionProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/TipoPromocion/', token)
            .then( ({ data } : { data : TipoPromocionProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerTipoPromociones = () => {

    return new Promise<TipoPromocionProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/TipoPromocion/ObtenerTipoPromociones', token)
            .then( ({ data } : { data : TipoPromocionProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ActualizarTipoPromocion = ( params: TipoPromocionProps ) => {

    return new Promise<TipoPromocionProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/TipoPromocion/Actualizar', params, token)
            .then( ({ data } : { data : TipoPromocionProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idTipoPromocion: 0,                 
                    descripcion: '',
                    activo: false,     
                });
            });
        }

    });

}

export const AgregarTipoPromocion = ( params: TipoPromocionProps ) => {

    return new Promise<TipoPromocionProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/TipoPromocion/Agregar', params, token)
            .then( ({ data } : { data : TipoPromocionProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idTipoPromocion: 0,
                    descripcion: '',
                    activo: false,    
                });
            });
        }

    });

}